import AppSkill from './AppSkill.json';
import AppCharacter from './AppCharacter.json';
import AppScore from './AppScore.json';
import AppAptitude from './AppAptitude.json';
import AppUser from './AppUser.json';
import AppCommon from './AppCommon.json';
import AppStat from './AppStat.json';
import AppSupport from './AppSupport.json';
import AppSupportSearch from './AppSupportSearch.json';
import AppSkillsManagement from './AppSkillsManagement.json';
import AppWelcome from './AppWelcome.json';
import SupportCards from './SupportCards.json';
import SupportDeckBonus from './SupportDeckBonus.json';
import SupportAnalytics from './SupportAnalytics.json';
import SupportComparator from './SupportComparator.json';
import SupportFilter from './SupportFilter.json';
import SupportsBests from './SupportsBests.json';
import SupportTable from './SupportTable.json';
import CloudDecks from './CloudDecks.json';
import DeckEventSummary from './DeckEventSummary.json';
import RaceSearch from './RaceSearch.json';
import RaceList from './RaceList.json';
import MiniGames from './MiniGames.json';
import About from './About.json';
import MetaAbout from './Meta-en/MetaAbout.json';
import MetaRaceList from './Meta-en/MetaRaceList.json';
import MetaWelcome from './Meta-en/MetaWelcome.json';
import MetaLogin from './Meta-en/MetaLogin.json';
import MetaRegister from './Meta-en/MetaRegister.json';
import MetaCharactersOriginal from './Meta-en/MetaCharactersOriginal.json';
import MetaScoreCalculator from './Meta-en/MetaScoreCalculator.json';
import MetaSupportComparator from './Meta-en/MetaSupportComparator.json';
import MetaMiniGamesHub from './Meta-en/MetaMiniGamesHub.json';
import MetaGuessWho from './Meta-en/MetaGuessWho.json';
import MetaGuessWhoBoard from './Meta-en/MetaGuessWhoBoard.json';
import MetaRequestPassChange from './Meta-en/MetaRequestPassChange.json';
import MetaResetPassword from './Meta-en/MetaResetPassword.json';
import MetaSkills from './Meta-en/MetaSkills.json';

const resources = {
    ...AppSkill,
    ...AppCharacter,
    ...AppScore,
    ...AppAptitude,
    ...AppUser,
    ...AppCommon,
    ...AppStat,
    ...AppSupport,
    ...AppSupportSearch,
    ...AppSkillsManagement,
    ...AppWelcome,
    ...SupportCards,
    ...SupportDeckBonus,
    ...SupportAnalytics,
    ...SupportComparator,
    ...SupportFilter,
    ...SupportsBests,
    ...SupportTable,
    ...CloudDecks,
    ...DeckEventSummary,
    ...RaceSearch,
    ...RaceList,
    ...MiniGames,
    ...About,
    ...MetaAbout,
    ...MetaRaceList,
    ...MetaWelcome,
    ...MetaLogin,
    ...MetaRegister,
    ...MetaCharactersOriginal,
    ...MetaScoreCalculator,
    ...MetaSupportComparator,
    ...MetaMiniGamesHub,
    ...MetaGuessWho,
    ...MetaGuessWhoBoard,
    ...MetaRequestPassChange,
    ...MetaResetPassword,
    ...MetaSkills
};

export default resources;
